import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Input} from "reactstrap"

class LimitTable extends Component {
    _handleChangeLimit = (e) => {
        const {value} = e.target
        const limit = parseInt(value)
        const {onChangePagination} = this.props

        if (typeof onChangePagination === 'function') {
            onChangePagination({limit})
        }
    }

    render() {
        const {limit} = this.props

        return (
            <div className='d-flex align-items-center'>Show
                <Input
                    className='mx-2'
                    type='select'
                    value={limit}
                    onChange={this._handleChangeLimit}
                >
                    <option>10</option>
                    <option>50</option>
                    <option>100</option>
                    <option>200</option>
                    <option>500</option>
                    <option>1000</option>
                    <option>2000</option>
                    <option>5000</option>
                </Input>
                entries
            </div>
        )
    }
}

LimitTable.propTypes = {
    limit: PropTypes.number.isRequired,
    onChangePagination: PropTypes.func.isRequired
}

export default LimitTable
